// removed by extract-text-webpack-plugin
module.exports = {"button":"_1_mLpoUZr6usMBd0keP_R_","signatureConfirm":"_2vVEJLXVb1xePnWed_c2Kj","LoanAmountRequested":"_1uCSK5qZ77OZ9IXL2h5eUl"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/Application/style.scss
// module id = 2139
// module chunks = 1